import { DateTime } from 'luxon';

import { HostDailySeries } from '../../../domain/models/image-per-day';

export class ImagesPerDay {
    public days: number;
    public series: HostDailySeries[];
    public validUntil?: DateTime;

    constructor() {
        this.validUntil = null;
        this.series = [];
    }
}
